import styled from "styled-components";

export const BoxReport = styled.div`
    .MuiPaper-root {
        height: auto;
    }
    .title-content {
        color: #333;
        text-transform: capitalize;
        font-weight: 500;
        font-size: 0.875rem;
        line-height: 20px;
        padding: 0;
    }

    .box-icon {
        
        color:${process.env.NODE_ENV === 'development' ? "#5a8dee" : process.env.REACT_APP_PRODUCT_BASE_COLOR};
        height: 50px;
        width: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 5px;
    }
    .box-content {
        display: flex;
        align-items: center;
        cursor: pointer;
        flex-direction:column;
        border-radius: 0.5rem;
        border:2px solid ${process.env.NODE_ENV === 'development' ? '#e5edfc' :process.env.REACT_APP_PRODUCT_BASE_COLOR2};
        padding:8px;
        &:hover{
            box-shadow: inherit;
        }
    }
    .title-icon {
        display: flex;
        align-items: center;
        width: 36px;
        height: 36px;
        border-radius: 50%;
        border: 1px dashed ${process.env.NODE_ENV === 'development' ? "#e5edfc" :process.env.REACT_APP_PRODUCT_BASE_COLOR2};
        flex: 0 0 36px;
        justify-content: center;
        background: ${process.env.NODE_ENV === 'development' ? "#e5edfc" : process.env.REACT_APP_PRODUCT_BASE_COLOR2};
    }
`
